import 'whatwg-fetch';
import autocompleteCompanyInput from './autocompleteCompanyInput';
import scrollToEl from '../helpers/scrollToEl';

const isValidEmail = (value) =>
	/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);

class FlexibleContactForm {
	static transformFieldToRuleName(name) {
		const transformNames = {
			first_name: 'name',
			last_name: 'name',
			company_name: 'company',
		};

		let fieldName = name;

		if (transformNames[name]) {
			fieldName = transformNames[name];
		}

		return fieldName;
	}

	constructor(form) {
		this.form = form;
		this.formKey = this.form.getAttribute('data-form-id');

		if (wp_data.contactForms[this.formKey]) {
			this.requiredFields = wp_data.contactForms[this.formKey].fields;
		} else {
			this.requiredFields = [];
		}

		this.asyncErrors = [];
		this.invalidFields = [];
		this.submitCount = 0;

		this.initCompanyInputs();
		this.addEventListeners();

		this.handleFileInputChange = this.handleFileInputChange.bind(this);
	}

	initCompanyInputs() {
		const input = this.form.querySelector(`input[name="contact_${this.formKey}_company_name"]`);
		const inputId = this.form.querySelector(`input[name="contact_${this.formKey}_company_id"]`);

		if (input && inputId) {
			autocompleteCompanyInput(input, inputId);

			input.addEventListener('keydown', function (e) {
				if ((e.keyCode >= 48 && e.keyCode <= 90) || e.keyCode == 8 || e.keyCode == 46) {
					inputId.value = '';
				}
			});
		}
	}

	addEventListeners() {
		this.form.addEventListener('change', this.handleFormChange.bind(this));
		this.form.addEventListener('submit', this.submitForm.bind(this));
	}

	handleFormChange(e) {
		if (this.submitCount) {
			if ((e.target.nodeName === 'INPUT' && ['text', 'email'].indexOf(e.target.type) > -1) || e.target.nodeName === 'TEXTAREA') {
				const name = e.target.name.split(/contact_\d*_/g).pop();
				const ruleName = FlexibleContactForm.transformFieldToRuleName(name);
				const index = this.invalidFields.indexOf(name);

				if (index > -1 && this.isFieldValid(name, this.requiredFields[ruleName])) {
					this.invalidFields.splice(index, 1);
					e.target.classList.remove('error');
				}
			}
		}
	}

	submitForm(e) {
		e.preventDefault();
		const that = this;
		const event = e;

		grecaptcha.ready(function () {
			grecaptcha.execute('6LfZRJseAAAAACOQyAY2r75hi72Vs3CCfJfU1t0Q', { action: 'submit' }).then(function (token) {
				var input = document.createElement('input');
				input.setAttribute('type', 'hidden');
				input.setAttribute('name', 'g-recaptcha-token');
				input.setAttribute('value', token);

				that.form.appendChild(input);
				that.handleFormSubmit(event);
			});
		});
	}

	handleFormSubmit(e) {
		e.preventDefault();

		if (!this.isFormValid()) {
			this.displayInvalidFields();
			this.submitCount += 1;
			this.hideLoading();
			return;
		}

		this.displayLoading();

		fetch(`${wp_data.ajaxUrl}`, {
			method: 'POST',
			body: this.buildRequestFormData(),
		})
			.then((response) => response.json())
			.then((response) => {
				// Validation error (probably invalid filetype)
				if (response.status === 'fail') {
					this.handleFailedResponse(response.data);
					this.hideLoading();
				}

				if (response.status === 'success') {
					window.location.href = wp_data.contactForms[this.formKey].redirect;
				}
			});
	}

	handleFailedResponse(errors) {
		this.asyncErrors = errors;

		if (errors.indexOf('file_attachment') > -1) {
			const fileInput = this.form.querySelector('input[type="file"]');

			if (fileInput) {
				fileInput.classList.add('error');
				fileInput.addEventListener('change', this.handleFileInputChange);

				const message = fileInput.parentNode.querySelector('.m-form__error-message');

				if (message) {
					message.classList.remove('hidden');
				}
			}
		}

		if (errors.indexOf('company_id') > -1) {
			const companyInput = this.form.querySelector(`input[name="contact_${this.formKey}_company_name"]`);

			if (companyInput) {
				companyInput.classList.add('error');
				companyInput.addEventListener('change', this.handleCompanyInputChange);
			}
		}

		errors.forEach((field) => {
			const fieldInput = this.form.querySelector(`[name="contact_${this.formKey}_${field}"]`);

			if (fieldInput) {
				fieldInput.classList.add('error');
				fieldInput.addEventListener('change', this.handleCompanyInputChange);
			}
		});
	}

	handleFileInputChange(e) {
		const index = this.asyncErrors.indexOf('file_attachment');

		if (index > -1) {
			this.asyncErrors.splice(index, 1);
			e.currentTarget.classList.remove('error');

			const message = e.currentTarget.parentNode.querySelector('.m-form__error-message');

			if (message) {
				message.classList.add('hidden');
			}
		}

		e.currentTarget.removeEventListener('change', this.handleFileInputChange);
	}

	handleCompanyInputChange(e) {
		e.currentTarget.classList.remove('error');
		e.currentTarget.removeEventListener('change', this.handleCompanyInputChange);
	}

	isFormValid() {
		const fields = this.form.querySelectorAll('input[type="text"], input[type="email"], textarea');
		this.invalidFields = [];

		for (let i = 0; i < fields.length; i++) {
			const name = fields[i].name.split(/contact_\d*_/g).pop();
			const ruleName = FlexibleContactForm.transformFieldToRuleName(name);

			if (!this.isFieldValid(name, this.requiredFields[ruleName])) {
				this.invalidFields.push(name);
			}
		}

		if (this.requiredFields.company && !this.isFieldValid('company_id', true)) {
			this.invalidFields.push('company_id');
		}

		return this.invalidFields.length === 0;
	}

	isFieldValid(name, required = false) {
		const el = this.form.querySelector(`[name="contact_${this.formKey}_${name}"]`);

		if (!el || !required) return true;

		const value = el.value.trim();

		if (!value.length) {
			return false;
		}

		if (name === 'email' && !isValidEmail(value)) {
			return false;
		}

		if (name === 'company_id' && !/^\d+$/.test(value)) {
			return false;
		}

		return true;
	}

	displayInvalidFields() {
		let firstEl = null;

		console.log(this.invalidFields);

		for (let i = 0; i < this.invalidFields.length; i++) {
			const name = this.invalidFields[i];

			let el;

			if (name === 'company_id') {
				el = this.form.querySelector(`[name="contact_${this.formKey}_company_name"]`);
			} else {
				el = this.form.querySelector(`[name="contact_${this.formKey}_${name}"]`);
			}

			if (!el) continue;

			if (!firstEl) {
				firstEl = el;
			}

			el.classList.add('error');
		}

		if (firstEl) {
			scrollToEl(firstEl);
		}
	}

	displayLoading() {
		this.form.classList.add('m-form--loading');
	}

	hideLoading() {
		this.form.classList.remove('m-form--loading');

		this.form.querySelector('button[type="submit"]').classList.remove('loading');
		this.form.querySelector('button[type="submit"]').disabled = false;
	}

	buildRequestFormData() {
		const formData = new FormData();

		formData.append('_nonce', wp_data.contactFormNonce);
		formData.append('action', 'create_contact_submission');
		formData.append('post_id', wp_data.postId);
		formData.append('form_key', this.formKey);

		const fields = this.form.querySelectorAll('input[type="text"], input[type="email"], input[type="file"], input[type="hidden"], textarea, select');

		for (let i = 0; i < fields.length; i++) {
			const validFieldNames = [
				'first_name',
				'last_name',
				'company_name',
				'company_id',
				'email',
				'telephone',
				'role',
				'subject',
				'comment',
				'file_attachment',
				'full_name',
				'city',
				'g-recaptcha-token',
			]; // full_name and city are honeypot fields
			const name = fields[i].name.split(/contact_\d*_/g).pop();

			if (validFieldNames.indexOf(name) > -1) {
				if (name === 'file_attachment' && fields[i].files) {
					formData.append('file_attachment', typeof fields[i].files[0] !== 'undefined' ? fields[i].files[0] : null);
				} else {
					formData.append(name, fields[i].value);
				}
			}
		}

		return formData;
	}
}

const flexibleFormSelectors = [
	'.page-template-default .m-form:not(.m-form--gravityform)',
	'.page-template-tpl-data-attributes .m-form:not(.m-form--gravityform)',
	'.plugins-template-default .m-form:not(.m-form--gravityform)',
	'.single-api .m-form:not(.m-form--gravityform)',
];

const forms = document.querySelectorAll(flexibleFormSelectors.join(', '));

if (forms.length != 0) {
	document.write('<script src="https://www.google.com/recaptcha/api.js?render=6LfZRJseAAAAACOQyAY2r75hi72Vs3CCfJfU1t0Q"></script>');

	for (let i = 0; i < forms.length; i++) {
		new FlexibleContactForm(forms[i]);
	}
}
